import { morphdomHold } from "web-ui/morphdom/hold"

export function ClearButtonPlugin() {
  const tomSelect = this
  let inputHold = null

  tomSelect.on("initialize", () => {
    const button = document.createElement("button")
    button.setAttribute("type", "button")
    button.setAttribute("title", "Clear")
    button.setAttribute("class", "clear-button")

    tomSelect.control.appendChild(button)

    button.addEventListener("click", (e) => {
      clearItem()
      e.preventDefault()
      e.stopPropagation()
    })

    button.addEventListener("keydown", (e) => {
      const navigationKeys = ["Tab", "Escape", "PageDown", "PageUp", "End", "Home"]

      if (navigationKeys.includes(e.key)) {
        return
      }

      if (e.key === "Enter") {
        clearItem()
      }

      e.preventDefault()
      e.stopPropagation()
    })

    button.addEventListener("focus", (e) => {
      inputHold ??= morphdomHold(tomSelect.input)
    })

    button.addEventListener("blur", (e) => {
      releaseInput()
    })
  })

  // The button is removed with the wrapper when Tom Select is destroyed, so
  // its blur may never arrive to release the hold on the input.
  // - Shaun, Wed Oct 7 2026
  tomSelect.on("destroy", () => {
    releaseInput()
  })

  function releaseInput() {
    if (inputHold) {
      inputHold.release()
      inputHold = null
    }
  }

  function clearItem() {
    tomSelect.clear()

    if (!tomSelect.isOpen) {
      tomSelect.focus_node.focus()
    } else {
      tomSelect.refreshOptions()
    }
  }

  tomSelect.hook("after", "setup", () => {
    // Tom select will insert a blank option when configured for single mode and no options are present
    // Remove the blank option from the list of search results - Matt, Stephen, Fri Nov 14 2025
    delete tomSelect.options[""]
    tomSelect.refreshOptions(false)
  })
}
